export class GcpSecretManagerRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSecretManagerRef.attributeTypeMap;
    }
    constructor() {
    }
}
